import React from 'react'
import { GoogleMap, } from '@react-google-maps/api'
import { getOrExtendAddressListBounds, } from '../../util/mapCalcs'
import ProgramAddressCollection from './ProgramAddressCollection'
import PropTypes from 'prop-types'
 
const center = {
  lat : 47.568343,
  lng : -120.191523,
}
const noop = () => {}

function ProgramDetailMap ({ 
  activeAddressIndex = null,
  addresses = [], 
  containerStyle = { height: '100%', width: '100%', },
  mapLibReady = false,
  occupationName = '',
  programName = '',
  programType = '',
  setActiveAddressIndex = noop,
  subscribeChanges = noop,
  userLocation = null,
}) {

  const [ map, setMap, ] = React.useState(null)
  const [ bounds, setBounds, ] = React.useState(null)
  // map init callback
  const onLoad = React.useCallback(function callback (map) { 
    if (mapLibReady){
      setMap(map) 
      if (!bounds) {
        setBounds(getOrExtendAddressListBounds(addresses))
      }
    }
  }, [ mapLibReady, bounds, addresses , ])

  // map unload callback
  const onUnmount = React.useCallback(function callback () { 
    setMap(null) 
  }, [])
  
  const boundsString = bounds ? JSON.stringify(bounds) : null

  // when bounds or map change in state, update the map
  React.useEffect(() => {
    if (mapLibReady && map && boundsString) {
      // eslint-disable-next-line no-undef
      google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
        map.setZoom(Math.min(15, map.getZoom()))
      })
      map.fitBounds(bounds)
    }
  },  [ mapLibReady, map, boundsString, bounds , ])


  /**
   * Register callback for when detail is loaded
   * just incase the detail record provides more addresses
   * or something
   */
  React.useEffect(() => {
    function resetBounds (newAddresses) {
      const newBounds = getOrExtendAddressListBounds(newAddresses)
      setBounds(newBounds)
    }
    if (mapLibReady && subscribeChanges) {
      subscribeChanges(resetBounds)
      return () => {
        subscribeChanges(null)
      }
    }
  }, [ subscribeChanges, mapLibReady, ])

  const renderMap = () => {
    return (
      <GoogleMap
        center={center}
        clickableIcons={false}
        mapContainerStyle={containerStyle}
        onLoad={onLoad}
        onUnmount={onUnmount}
        zoom={10}
      >
        <ProgramAddressCollection
          activeIndex={activeAddressIndex}
          locations={addresses}
          programName={programName}
          programOccupation={occupationName}
          programType={programType}
          setActiveIndex={setActiveAddressIndex}
          userLocation={userLocation}
        />
      </GoogleMap>
    )
  }

  return renderMap()
}

ProgramDetailMap.propTypes = {
  activeAddressIndex    : PropTypes.oneOfType([ PropTypes.string, PropTypes.number, ]),
  addresses             : PropTypes.array, 
  containerStyle        : PropTypes.object,
  mapLibReady           : PropTypes.bool,
  occupationName        : PropTypes.string,
  programName           : PropTypes.string,
  programType           : PropTypes.string,
  setActiveAddressIndex : PropTypes.func,
  subscribeChanges      : PropTypes.func,
}

export default React.memo(ProgramDetailMap)